import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import OrganizationBrandAppResource from './OrganizationBrandAppResource';
import OrganizationDivisionAppResource from './OrganizationDivisionAppResource';

class OrganizationOperationAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'organization-operation';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'organizations/operations';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'createdAt',
            'updatedAt',
            'name',
            'city',
            'state',
            'zipCode',
            'organizationDivisionUuid',
            'organizationBrandUuid',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            brand: OrganizationBrandAppResource,
            division: OrganizationDivisionAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            brand: 'organization_brand_uuid',
            division: 'organization_division_uuid'
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            city: {
                type: 'string',
                presence: false,
                length: {
                    maximum: 255,
                },
            },
            state: {
                type: 'string',
                presence: false,
                length: {
                    maximum: 255,
                },
            },
            zipCode: {
                type: 'string',
                presence: false,
                length: {
                    maximum: 255,
                },
            },
            name: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            organizationDivisionUuid: {
                type: 'string',
                presence: true,
            },
            organizationBrandUuid: {
                type: 'string',
                presence: true,
            },
        };
    }

}

export default OrganizationOperationAppResource;
